import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
const AdminEvent = () => {
  const [result, setResult] = useState({});
  const [updateDOM, setUpdateDOM] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const getData = async () => {
      let accessToken = getBearerString();
      let headers = {
        headers: {
          Authorization: accessToken,
        },
      };
      try {
        let response = await axios.get(
          `${root_url}/api/admin/event/DCM21`,
          headers
        );
        console.log(response.data);
        setResult(response.data);
        setUpdateDOM(response.data);
        setIsLoading(false);
      } catch (e) {
        if (e?.response?.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.errorMessage);
        }
      }
    };
    getData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("updateDOM >>> ", updateDOM);
    const formData = new FormData();
    if (updateDOM.file != null && updateDOM.file != undefined) {
      console.log("file : ", updateDOM.file);
      formData.append("file", updateDOM.file);
    }
    if (updateDOM.eventName != null && updateDOM.eventName != undefined) {
      console.log("eventName : ", updateDOM.eventName);
      formData.append("eventName", updateDOM.eventName);
    }
    if (updateDOM.subscript != null && updateDOM.subscript != undefined) {
      console.log("subscript : ", updateDOM.subscript);
      formData.append("subscript", updateDOM.subscript);
    }
    if (updateDOM.homeUrl != null && updateDOM.homeUrl != undefined) {
      console.log("homeUrl : ", updateDOM.homeUrl);
      formData.append("homeUrl", updateDOM.homeUrl);
    }
    if (updateDOM.companyNo != null && updateDOM.companyNo != undefined) {
      console.log("companyNo : ", updateDOM.companyNo);
      formData.append("companyNo", updateDOM.companyNo);
    }
    if (updateDOM.organizer != null && updateDOM.organizer != undefined) {
      console.log("organizer : ", updateDOM.organizer);
      formData.append("organizer", updateDOM.organizer);
    }
    if (updateDOM.managerName != null && updateDOM.managerName != undefined) {
      console.log("managerName : ", updateDOM.managerName);
      formData.append("managerName", updateDOM.managerName);
    }
    if (updateDOM.cellphone != null && updateDOM.cellphone != undefined) {
      console.log("cellphone : ", updateDOM.cellphone);
      formData.append("cellphone", updateDOM.cellphone);
    }
    if (updateDOM.email != null && updateDOM.email != undefined) {
      console.log("email : ", updateDOM.email);
      formData.append("email", updateDOM.email);
    }
    if (updateDOM.accountNo != null && updateDOM.accountNo != undefined) {
      console.log("accountNo : ", updateDOM.accountNo);
      formData.append("accountNo", updateDOM.accountNo);
    }
    let accessToken = getBearerString();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: accessToken,
      },
    };
    const sendData = async () => {
      try {
        let response = await axios.post(
          `${root_url}/api/admin/event`,
          formData,
          config
        );
        console.log(response.data);
      } catch (e) {
        if (e?.response?.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.errorMessage);
        }
      }
    };
    sendData();
  };
  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        기본정보
      </h1>
      {isLoading ? (
        ""
      ) : (
        <Form className="mt-5" onSubmit={handleSubmit}>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              대회사진
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  console.log(file.name);
                  setUpdateDOM({ ...updateDOM, file: file });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              대회명칭
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.eventName}
                onChange={(e) => {
                  console.log(e.target.value);
                  const eventName = e.target.value;
                  setUpdateDOM({ ...updateDOM, eventName: eventName });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              대회 개요
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.subscript}
                onChange={(e) => {
                  console.log(e.target.value);
                  const subscript = e.target.value;
                  setUpdateDOM({ ...updateDOM, subscript: subscript });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              계좌
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.accountNo}
                onChange={(e) => {
                  console.log(e.target.value);
                  const accountNo = e.target.value;
                  setUpdateDOM({ ...updateDOM, accountNo: accountNo });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              URL
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.homeUrl}
                onChange={(e) => {
                  console.log(e.target.value);
                  const homeUrl = e.target.value;
                  setUpdateDOM({ ...updateDOM, homeUrl: homeUrl });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              사업자번호
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.companyNo}
                onChange={(e) => {
                  console.log(e.target.value);
                  const companyNo = e.target.value;
                  setUpdateDOM({ ...updateDOM, companyNo: companyNo });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              주최자
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.organizer}
                onChange={(e) => {
                  console.log(e.target.value);
                  const organizer = e.target.value;
                  setUpdateDOM({ ...updateDOM, organizer: organizer });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              관리자명
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.managerName}
                onChange={(e) => {
                  console.log(e.target.value);
                  const managerName = e.target.value;
                  setUpdateDOM({ ...updateDOM, managerName: managerName });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              휴대전화
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.cellphone}
                onChange={(e) => {
                  console.log(e.target.value);
                  const cellphone = e.target.value;
                  setUpdateDOM({ ...updateDOM, cellphone: cellphone });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              이메일
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                defaultValue={result.email}
                onChange={(e) => {
                  console.log(e.target.value);
                  const email = e.target.value;
                  setUpdateDOM({ ...updateDOM, email: email });
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              대회 시작일자
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                disabled
                defaultValue={result.eventOpen?.split("T")[0]}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              대회 종료일자
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                disabled
                defaultValue={result.eventClose?.split("T")[0]}
              />
            </Col>
          </Form.Group>
          <Button
            type="submit"
            className="bg-custom-color cursor-pointer text-white text-center rounded-pill p-2"
          >
            저장하기
          </Button>
        </Form>
      )}
    </Container>
  );
};

export default AdminEvent;
